import * as actions from "../redux/actions/auth";
const { REACT_APP_REFRESH_TIME } = process.env;

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    async (config) => {
      const {
        auth: { token, expiresIn, needRefresh },
      } = store.getState();

      const { dispatch } = store;

      const now = Date.now();
      if (
        expiresIn &&
        expiresIn - now < REACT_APP_REFRESH_TIME &&
        needRefresh
      ) {
        dispatch(actions.refreshToken());
        const {
          auth: { token },
        } = store.getState();
        config.headers.Authorization = `Bearer ${token}`;
      }

      if (expiresIn && now > expiresIn) {
        dispatch(actions.logout());
      }

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (err) => {
      return Promise.reject(err);
    }
  );
}
